import React, { useRef } from 'react'
import { Icon } from '@components/UI'

import Tab from './Tab'
import { ClassroomManager } from '@helpers'
import { useClassroomPermissions } from '../../contexts'
import { Classroom as CC } from '../../../../constants'

const TabBar = ({ tabs, active, activate, create, close }) => {
  const wrapper = useRef(null)

  const { checkPermission } = useClassroomPermissions()
  const canCreateFile = checkPermission(CC.FEATURES.TOOL_NEW_FILE)

  return (
    <div
      className='gp-frame-footer'
      ref={wrapper}
      onWheel={(e) => {
        if (!e.deltaX) {
          wrapper.current.scrollLeft += e.deltaY
        }
      }}
    >
      {Object.keys(tabs).map((v) => (
        <Tab
          key={v}
          id={tabs[v].data.id}
          name={tabs[v].data.name}
          active={v === active}
          activate={() => active !== v && activate(v)}
          close={() => close(v)}
        />
      ))}
      {canCreateFile ? (
        <div className={`add-btn-container`}>
          <Icon
            name='plus'
            events={{
              onClick: () => {
                if (ClassroomManager.isSynced()) create()
              }
            }}
          />
        </div>
      ) : null}
    </div>
  )
}

export default TabBar
